$(document).ready(function () {
  if(window.innerWidth >= 992) {
    AOS.init({
      once: true,
      disable: function () {
        var maxWidth = 992;
        return window.innerWidth < maxWidth;
      }
    });
  }
  $('.leadersip-card').click(function (e) {
    e.preventDefault();
    if($(e.target).hasClass('close')) {
        $(this).addClass('deactivating');
        setTimeout(deactivatingLeader, 500, $(this));
        $(this).removeClass('active');
    } else {
        if($('.leadersip-card.active')[0] !== $(this)[0]){
            $('.leadersip-card.active').addClass('deactivating');
            setTimeout(deactivatingLeader, 500, $('.leadersip-card.active'));
            $('.leadersip-card.active').removeClass('active');
        }
        $(this).addClass('active');
    }
  });
  if (window.location.hash.length > 0) {
    var url_hash = window.location.hash.replace(/\/$/, "");
    console.log(url_hash);
    $(url_hash).addClass('active');
  }
});
function deactivatingLeader(element) {
    $(element).removeClass('deactivating');
}